var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, InfoTag, Radio, Typography, isLastItem, getTestId, DynamicSvg } from '@airtel/air-design-system';
import { useEffect } from 'react';
import { View } from 'react-native';
import { getRadioGroupWidgetStyles, getRadioInfoTagWidgetStyles, getRadioLeftLabelGroupWidgetStyles } from './RadioGroupWidgetStyles';
export var RadioGroupWidgetComponent = props => {
  var id = props.id,
    title = props.title,
    radioButtons = props.radioButtons,
    style = props.style,
    _props$radioDirection = props.radioDirection,
    radioDirection = _props$radioDirection === void 0 ? 'row' : _props$radioDirection,
    onSelection = props.onSelection,
    onSelectionHandler = props.onSelectionHandler,
    _props$checkedRadioId = props.checkedRadioId,
    checkedRadioId = _props$checkedRadioId === void 0 ? '' : _props$checkedRadioId,
    onUserAction = props.onUserAction,
    _props$showOptionNumb = props.showOptionNumber,
    showOptionNumber = _props$showOptionNumb === void 0 ? false : _props$showOptionNumb,
    _props$optionNumberTy = props.optionNumberType,
    optionNumberType = _props$optionNumberTy === void 0 ? 'numeric' : _props$optionNumberTy,
    testID = props.testID,
    radioButtonStyle = props.radioButtonStyle,
    radioContainerStyle = props.radioContainerStyle,
    _props$runSelectionOn = props.runSelectionOnMount,
    runSelectionOnMount = _props$runSelectionOn === void 0 ? true : _props$runSelectionOn,
    restProps = __rest(props, ["id", "title", "radioButtons", "style", "radioDirection", "onSelection", "onSelectionHandler", "checkedRadioId", "onUserAction", "showOptionNumber", "optionNumberType", "testID", "radioButtonStyle", "radioContainerStyle", "runSelectionOnMount"]);
  var radioGroupWidgetStyles = getRadioGroupWidgetStyles(radioDirection);
  useEffect(() => {
    if (checkedRadioId && runSelectionOnMount) {
      var index = radioButtons.findIndex(item => item.id === checkedRadioId);
      onSelectionHandler === null || onSelectionHandler === void 0 ? void 0 : onSelectionHandler(radioButtons[index]);
      onSelection && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onSelection), Object.assign(Object.assign({}, radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons[index]), {
        index: index
      })));
    }
  }, []);
  var onRadioItemPress = data => {
    onSelectionHandler === null || onSelectionHandler === void 0 ? void 0 : onSelectionHandler(data);
    var onRadioPressMetaData = data === null || data === void 0 ? void 0 : data.onRadioPressMetaData;
    onSelection && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onSelection), data));
    onRadioPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onRadioPressMetaData), data));
  };
  return _jsxs(View, Object.assign({}, getTestId(testID), {
    style: [radioGroupWidgetStyles.container, style]
  }, restProps, {
    children: [_jsx(Typography, Object.assign({
      style: radioGroupWidgetStyles.title,
      text: title,
      type: "body-single-line-xs",
      color: BLACK_700
    }, getTestId(testID, 'title'))), _jsx(View, Object.assign({
      style: [radioGroupWidgetStyles.radioButtons, radioContainerStyle]
    }, {
      children: radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.map((radioButton, index) => {
        var radioButtonsStyles = getRadioLeftLabelGroupWidgetStyles(radioDirection, radioButton === null || radioButton === void 0 ? void 0 : radioButton.labelPosition);
        var radioButtonInfoTagStyles = getRadioInfoTagWidgetStyles(radioButton);
        var label = radioButton === null || radioButton === void 0 ? void 0 : radioButton.label;
        if (showOptionNumber) {
          if (optionNumberType === 'numeric') {
            label = index + 1 + ". " + label;
          } else if (optionNumberType === 'alphabetic') {
            label = String.fromCharCode(index + 97) + ". " + label;
          }
        }
        return _jsxs(View, Object.assign({
          style: [radioButtonStyle, radioDirection === 'column' && radioGroupWidgetStyles.radioButtonOuterContainer]
        }, {
          children: [!!radioButton.iconName && _jsx(DynamicSvg, {
            iconName: radioButton === null || radioButton === void 0 ? void 0 : radioButton.iconName,
            style: radioButtonsStyles.iconSpacer
          }), _jsxs(View, Object.assign({
            style: radioGroupWidgetStyles.radioButtonContainer
          }, {
            children: [_jsx(Radio, Object.assign({
              style: [!isLastItem(radioButtons, index) && radioButtonsStyles.radio]
            }, radioButton, {
              label: label,
              checked: (radioButton === null || radioButton === void 0 ? void 0 : radioButton.checked) || (radioButton === null || radioButton === void 0 ? void 0 : radioButton.id) === checkedRadioId,
              accessibilityHint: ((radioButton === null || radioButton === void 0 ? void 0 : radioButton.checked) || (radioButton === null || radioButton === void 0 ? void 0 : radioButton.id) === checkedRadioId ? 'selected ' : 'unselected ') + ((radioButton === null || radioButton === void 0 ? void 0 : radioButton.accessibilityHint) || ''),
              onPress: data => onRadioItemPress(Object.assign(Object.assign({}, radioButton), data))
            }, getTestId(testID, 'radio'), {
              radioDisplay: radioDirection === 'row' ? 'inline' : 'block'
            }), "radio_group_item_" + (radioButton === null || radioButton === void 0 ? void 0 : radioButton.id) + "_" + index), !!(radioButton === null || radioButton === void 0 ? void 0 : radioButton.infoTagProps) && Object.keys(radioButton === null || radioButton === void 0 ? void 0 : radioButton.infoTagProps).length > 0 && _jsx(InfoTag, Object.assign({
              style: radioButtonInfoTagStyles.infoTag
            }, radioButton === null || radioButton === void 0 ? void 0 : radioButton.infoTagProps, getTestId(testID, 'infoTag')))]
          }))]
        }), "single_radio_item_" + index);
      })
    }))]
  }));
};
RadioGroupWidgetComponent.genericRendererKey = 'AirRadioGroupWidget';